export function signInRequest(email, password) {
  return {
    type: '@auth/SIGN_IN_REQUEST',
    payload: { email, password },
  };
}

export function signInSuccess(token, user, refreshToken) {
  return {
    type: '@auth/SIGN_IN_SUCCESS',
    payload: { token, user, refreshToken },
  };
}

export function refreshTokenRequest(refreshToken) {
  return {
    type: '@auth/REFRESH_TOKEN_REQUEST',
    payload: { refreshToken },
  };
}

export function refreshTokenSuccess(token, user, refreshToken) {
  return {
    type: '@auth/REFRESH_TOKEN_SUCCESS',
    payload: { token, user, refreshToken },
  };
}

export function updateRefreshToken(token, refreshToken) {
  return {
    type: '@auth/UPDATE_REFRESH_TOKEN',
    payload: { token, refreshToken },
  };
}

export function refreshTokenStart() {
  return {
    type: '@auth/UPDATING_TOKEN_START',
  };
}

export function signFailure() {
  return {
    type: '@auth/SIGN_FAILURE',
  };
}
export function signOut() {
  return {
    type: '@auth/SIGN_OUT',
  };
}
